import { render, staticRenderFns } from "./commonAnswer.vue?vue&type=template&id=92282a16&scoped=true"
import script from "./commonAnswer.vue?vue&type=script&lang=js"
export * from "./commonAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92282a16",
  null
  
)

export default component.exports